export const courseContent = {
  week1: {
    title: "Introduction to Resilience and Grit",
    pages: [
      {
        id: 1,
        type: "video",
        videoSrc: "https://d3sc34m1n26ele.cloudfront.net/resilience_grit_videos/Week+1/Week+1_1.mp4",
        hasNextButton: true,
      },
      {
        id: 2,
        type: "question",
        questionType: "text",
        question: "What do you understand by the word",
        hasImage: true,
        imageSrc: "mindset.png",
        inputType: "bigTextBox",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 3,
        type: "video",
        videoSrc: "https://d3sc34m1n26ele.cloudfront.net/resilience_grit_videos/Week+1/Week+1_2.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 4,
        type: "listQuestion",
        question:
          "Can you mention some challenges you have encountered and bounced back from?",
        inputCount: 5,
        inputType: "text",
        inputPlaceholder: "Type your answer here",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 5,
        type: "video",
        videoSrc: "https://d3sc34m1n26ele.cloudfront.net/resilience_grit_videos/Week+1/Week+1_3.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 6,
        type: "question",
        questionType: "text",
        question: "What do you understand by the word",
        hasImage: true,
        imageSrc: "mindset.png",
        inputType: "bigTextBox",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 7,
        type: "video",
        videoSrc: "https://d3sc34m1n26ele.cloudfront.net/resilience_grit_videos/Week+1/Week+1_4.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 8,
        type: "multiStep",
        title: "Write a letter to yourself.",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            challenge: "Preparing for a big math test, and you don’t understand all the topics.",
            statement: "I don’t understand all the topics. yet., but I can keep studying and practicing until I do"
          },
          {
            stepId: 2,
            type: "imageDragAndDrop",
            instruction:
              "Drag-and-drop the statements on the left into any of these bowls.",
            steps: 4,
            buckets: [
              {
                id: "green",
                title: "Resilience",
              },
              {
                id: "red",
                title: "Grit",
              }

            ],
            images: [
              "Sam has been practicing the piano for months, even though learning new songs is really hard. He doesn’t give up, even when it takes a long time to get it right.",
              "Chris is writing a book. It’s taking a really long time, but he’s excited to finish it, even though it’s hard to think of new ideas sometimes.",
              "Emma’s science project didn’t go as planned. She felt frustrated, but after taking a deep breath, she decided to figure out how to fix it and finish her project.",
              "After losing a big game, Lucy felt sad, but she reminded herself to keep her head up and practice for the next one.",
            ]

          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 9,
        type: "video",
        videoSrc: "https://d3sc34m1n26ele.cloudfront.net/resilience_grit_videos/Week+1/Week+1_5.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 10,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            title: "Instruction",
            instructions: [
              "Below are sentences with missing words related to communication and boundaries. Choose the best word from the list below to complete each sentence.",
              "\n Missing words are: "
            ],
            options: "Respect, Clarity, Comfort, Listen, Express"
          },
          {
            stepId: 2,
            type: "multiColoredQuestionBoxes",
            fields: [
              {
                number: "Challenge",
                textFieldColor: "red",
                colorCode: "#FD483D",
              },
              {
                number: "Your YET Statement:",
                textFieldColor: "green",
                colorCode: "#4CB748",
              },
            ]
          },
          {
            stepId: 3,
            type: "multiColoredQuestionBoxes",
            fields: [
              {
                number: "Challenge",
                textFieldColor: "red",
                colorCode: "#FD483D",
              },
              {
                number: "Your YET Statement:",
                textFieldColor: "green",
                colorCode: "#4CB748",
              },
            ]
          },
          {
            stepId: 4,
            type: "multiColoredQuestionBoxes",
            fields: [
              {
                number: "Challenge",
                textFieldColor: "red",
                colorCode: "#FD483D",
              },
              {
                number: "Your YET Statement:",
                textFieldColor: "green",
                colorCode: "#4CB748",
              },
            ]
          },
          {
            stepId: 5,
            type: "multiColoredQuestionBoxes",
            fields: [
              {
                number: "Challenge",
                textFieldColor: "red",
                colorCode: "#FD483D",
              },
              {
                number: "Your YET Statement:",
                textFieldColor: "green",
                colorCode: "#4CB748",
              },
            ]
          },

        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 11,
        type: "video",
        videoSrc: "https://d3sc34m1n26ele.cloudfront.net/resilience_grit_videos/Week+1/Week+1_6.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
    ],
  },
  week2: {
    title: "Developing Resilience",
    pages: [
      {
        id: 1,
        type: "video",
        videoSrc: "https://d3sc34m1n26ele.cloudfront.net/resilience_grit_videos/Week+2/Week+2_1.mp4",
        hasNextButton: true,
      },
      {
        id: 2,
        type: "radio",
        question: "Just a quick question, have you ever seen or heard of a building that collapsed? ",
        options: [
          { id: "A", text: "YES" },
          { id: "B", text: "NO" },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 3,
        type: "video",
        videoSrc: "https://d3sc34m1n26ele.cloudfront.net/resilience_grit_videos/Week+2/Week+2_2.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 4,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            title: "Instruction",
            instructions: [
              "Match the right ‘C’ to their correct definition.",
            ],
            options: "Competence, Confidence, Coping, Control, Character, Connections, and Contribution."
          },

          {
            stepId: 2,
            type: "dropdownScenario",
            question: "The belief in your own ability to handle situations, challenges, and tasks with confidence and success.",
            options: [
              "Competence",
              "Confidence",
              "Coping",
              "Control",
              "Character",
              "Connections",
              "Contribution"
            ],
          },
          {
            stepId: 3,
            type: "dropdownScenario",
            question: "The people in your life who support, guide, and help you through challenges.",
            options: [
              "Competence",
              "Confidence",
              "Coping",
              "Control",
              "Character",
              "Connections",
              "Contribution"
            ],
          },
          {
            stepId: 4,
            type: "dropdownScenario",
            question: "Your values and sense of right and wrong that help guide your decisions and actions in difficult situations.",
            options: [
              "Competence",
              "Confidence",
              "Coping",
              "Control",
              "Character",
              "Connections",
              "Contribution"
            ],
          },
          {
            stepId: 5,
            type: "dropdownScenario",
            question: "The skills and strategies you use to manage stress, challenges, and emotions in tough situations.",
            options: [
              "Competence",
              "Confidence",
              "Coping",
              "Control",
              "Character",
              "Connections",
              "Contribution"
            ],
          },

          {
            stepId: 6,
            type: "dropdownScenario",
            question: "The understanding that you can contribute positively to the world around you, helping others and making a difference.",
            options: [
              "Competence",
              "Confidence",
              "Coping",
              "Control",
              "Character",
              "Connections",
              "Contribution"
            ],
          },
          {
            stepId: 7,
            type: "dropdownScenario",
            question: "The ability to successfully perform tasks or overcome challenges by using your skills, knowledge, and abilities.",
            options: [
              "Competence",
              "Confidence",
              "Coping",
              "Control",
              "Character",
              "Connections",
              "Contribution"
            ],
          },
          {
            stepId: 8,
            type: "dropdownScenario",
            question: "The feeling of being in charge of your own actions, responses, and decisions, even if you can’t control everything around you.",
            options: [
              "Competence",
              "Confidence",
              "Coping",
              "Control",
              "Character",
              "Connections",
              "Contribution"
            ],
          },

        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 5,
        type: "video",
        videoSrc: "https://d3sc34m1n26ele.cloudfront.net/resilience_grit_videos/Week+2/Week+2_3.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
    ],
  },
  week3: {
    title: "Understanding the Concept of Adaptability and Its Application",
    pages: [
      {
        id: 1,
        type: "video",
        videoSrc: "https://d3sc34m1n26ele.cloudfront.net/resilience_grit_videos/Week+3/Week+3_1.mp4",
        hasNextButton: true,
      },
      {
        id: 2,
        type: "question",
        questionType: "text",
        question: "What do you understand by the word",
        hasImage: true,
        imageSrc: "mindset.png",
        inputType: "bigTextBox",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 3,
        type: "video",
        videoSrc: "https://d3sc34m1n26ele.cloudfront.net/resilience_grit_videos/Week+3/Week+3_2.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },

      {
        id: 4,
        type: "imageDragAndDrop",
        instruction:
          "Drag-and-drop the statements on the left into any of these bowls",
        images: [
          "Ability to adjust to new situations, changes, or challenges.",
          "Expecting everything to stay the same and being frustrated when it doesn’t.",
          "Does not mean you have to like change all the time.",
          "Sticking to just one way of doing things, even when it’s not working.",
          "Staying calm, thinking through the situation, and coming up with a new plan.",
          "Refusing to try new things because they seem too hard.",
          "Being open to trying new things and not getting stuck when things don’t go according to plan.",
          "Avoiding change or pretending it’s not happening.",
          "Knowing how to handle change when it happens.",
          "Panicking when something unexpected happens."
        ],
        buckets: [
          {
            id: "green",
            label: "Adaptability",
            count: 5,
          },
          {
            id: "red",
            label: "Not Adaptability",
            count: 5,
          },
        ],
        steps: 10,
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 5,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            title: "Instruction",
            instructions: [
              "For each situation, explain how you will adapt in the given situation.",
            ],

          },
          {
            stepId: 2,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question: "You’re feeling overwhelmed with schoolwork and aren’t sure how to manage all the assignments and exams coming up."
              }
            ]
          },
          {
            stepId: 3,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question: "Your friend is going through a tough time, and you decide to spend some time with them to listen and offer support."
              }
            ]
          },
          {
            stepId: 4,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question: "You’ve recently learned how to play the guitar, and although it was tough in the beginning, you kept practicing and now feel proud of what you’ve achieved."
              }
            ]
          },
          {
            stepId: 5,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question: "You’re in a situation where you don’t know the outcome, but you remind yourself to focus on what you can do and how you can handle your emotions."
              }
            ]
          },
          {
            stepId: 6,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question: "You volunteered at a local charity event and helped organize a charity event. You felt great knowing that you made a positive impact"
              }
            ]
          },
        ]

        ,
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 6,
        type: "video",
        videoSrc: "https://d3sc34m1n26ele.cloudfront.net/resilience_grit_videos/Week+3/Week+3_3.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
    ],
  },
  week4: {
    title: "The Role of Support Systems",
    pages: [
      {
        id: 1,
        type: "video",
        videoSrc: "https://d3sc34m1n26ele.cloudfront.net/resilience_grit_videos/Week+4/Week+4_1.mp4",
        hasNextButton: true,
      },
      {
        id: 2,
        type: "question",
        questionType: "text",
        question:
          "What do you understand by the word",
        inputType: "mediumTextBox",
        hasImage: true,
        imageSrc: "values.png",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 3,
        type: "video",
        videoSrc: "https://d3sc34m1n26ele.cloudfront.net/resilience_grit_videos/Week+4/Week+4_2.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 4,
        type: "listQuestion",
        question:
          "Who are the three top people you go to when you need help with a situation?",
        inputCount: 3,
        fields: [
          {
            number: "1",
            textFieldColor: "green",
            colorCode: "#4CB748",
          },
          {
            number: "2",
            textFieldColor: "orange",
            colorCode: "#FDD8B6",
          },

          {
            number: "3",
            textFieldColor: "blue",
            colorCode: "#01A7FF",
          },
        ],
        inputType: "text",
        inputPlaceholder: "Type your answer here",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 5,
        type: "video",
        videoSrc: "https://d3sc34m1n26ele.cloudfront.net/resilience_grit_videos/Week+4/Week+4_3.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 6,
        type: "multiStep",
        steps: [

          {
            stepId: 1,
            type: "instruction",
            title:
              "My Web of Relationship: ",
            subTitle: "Map out your support system.",
          },
          {
            stepId: 2,
            type: "fiveFieldsAnswers",
            question:
              "Write out what these people think about you.",
            answers: 5
          },

        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 7,
        type: "video",
        videoSrc: "https://d3sc34m1n26ele.cloudfront.net/resilience_grit_videos/Week+4/Week+4_4.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
    ],
  },
  week5: {
    title: "Coping Skills",
    pages: [
      {
        id: 1,
        type: "video",
        videoSrc: "https://d3sc34m1n26ele.cloudfront.net/resilience_grit_videos/Week+5/Week+5_1.mp4",
        hasNextButton: true,
      },
      {
        id: 2,
        type: "question",
        questionType: "text",
        question: "What do you understand by the word",
        hasImage: true,
        imageSrc: "mindset.png",
        inputType: "bigTextBox",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 3,
        type: "video",
        videoSrc: "https://d3sc34m1n26ele.cloudfront.net/resilience_grit_videos/Week+5/Week+5_2.mp4",
        hasNextButton: true,
      },
      {
        id: 4,
        type: "listQuestion",
        question:
          "Can you mention some challenges you have encountered and bounced back from?",
        inputCount: 5,
        inputType: "text",
        inputPlaceholder: "Type your answer here",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 5,
        type: "video",
        videoSrc: "https://d3sc34m1n26ele.cloudfront.net/resilience_grit_videos/Week+5/Week+5_3.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 6,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            title: "Instruction",
            instructions: [
              "Match a stressful situation to a coping skill you will use if you find yourself in such a situation.",
            ],
            options: ""
          },

          {
            stepId: 2,
            type: "dropdownScenario",
            question: "You have a big test tomorrow, and you're feeling nervous and overwhelmed.",
            options: [
              "Take deep breaths and count to ten.",
              "Write down how you feel in a journal.",
              "Take a short walk or move to a quiet space to cool down.",
              "Practice positive self-talk, like 'I can handle this'",
              "Talk to someone you trust.",
              "Break the problem into smaller steps and focus on one at a time.",
              "Listen to calming music.",
              "Ask for help or guidance from a teacher or friend.",
              "Visualize yourself doing well and succeeding.",
              "Do an activity like drawing or playing a game."
            ],
          },
          {
            stepId: 3,
            type: "dropdownScenario",
            question: "Your best friend said something that hurt your feelings, and now you're feeling upset.",
            options: [
              "Take deep breaths and count to ten.",
              "Write down how you feel in a journal.",
              "Take a short walk or move to a quiet space to cool down.",
              "Practice positive self-talk, like 'I can handle this'",
              "Talk to someone you trust.",
              "Break the problem into smaller steps and focus on one at a time.",
              "Listen to calming music.",
              "Ask for help or guidance from a teacher or friend.",
              "Visualize yourself doing well and succeeding.",
              "Do an activity like drawing or playing a game."
            ],
          },
          {
            stepId: 4,
            type: "dropdownScenario",
            question: "You are struggling to understand a math problem in class, and it's making you feel frustrated.",
            options: [
              "Take deep breaths and count to ten.",
              "Write down how you feel in a journal.",
              "Take a short walk or move to a quiet space to cool down.",
              "Practice positive self-talk, like 'I can handle this'",
              "Talk to someone you trust.",
              "Break the problem into smaller steps and focus on one at a time.",
              "Listen to calming music.",
              "Ask for help or guidance from a teacher or friend.",
              "Visualize yourself doing well and succeeding.",
              "Do an activity like drawing or playing a game."
            ],
          },
          {
            stepId: 5,
            type: "dropdownScenario",
            question: "You didn’t make the sports team you really wanted to join, and you feel disappointed.",
            options: [
              "Take deep breaths and count to ten.",
              "Write down how you feel in a journal.",
              "Take a short walk or move to a quiet space to cool down.",
              "Practice positive self-talk, like 'I can handle this'",
              "Talk to someone you trust.",
              "Break the problem into smaller steps and focus on one at a time.",
              "Listen to calming music.",
              "Ask for help or guidance from a teacher or friend.",
              "Visualize yourself doing well and succeeding.",
              "Do an activity like drawing or playing a game."
            ],
          },

          {
            stepId: 6,
            type: "dropdownScenario",
            question: "A group project is due tomorrow, but your team hasn’t finished their parts, and you're stressed.",
            options: [
              "Take deep breaths and count to ten.",
              "Write down how you feel in a journal.",
              "Take a short walk or move to a quiet space to cool down.",
              "Practice positive self-talk, like 'I can handle this'",
              "Talk to someone you trust.",
              "Break the problem into smaller steps and focus on one at a time.",
              "Listen to calming music.",
              "Ask for help or guidance from a teacher or friend.",
              "Visualize yourself doing well and succeeding.",
              "Do an activity like drawing or playing a game."
            ],
          },
          {
            stepId: 7,
            type: "dropdownScenario",
            question: "You're about to give a speech in front of the class, and you're feeling anxious.",
            options: [
              "Take deep breaths and count to ten.",
              "Write down how you feel in a journal.",
              "Take a short walk or move to a quiet space to cool down.",
              "Practice positive self-talk, like 'I can handle this'",
              "Talk to someone you trust.",
              "Break the problem into smaller steps and focus on one at a time.",
              "Listen to calming music.",
              "Ask for help or guidance from a teacher or friend.",
              "Visualize yourself doing well and succeeding.",
              "Do an activity like drawing or playing a game."
            ],
          },
          {
            stepId: 8,
            type: "dropdownScenario",
            question: "You lost your favorite item and feel sad about it.",
            options: [
              "Take deep breaths and count to ten.",
              "Write down how you feel in a journal.",
              "Take a short walk or move to a quiet space to cool down.",
              "Practice positive self-talk, like 'I can handle this'",
              "Talk to someone you trust.",
              "Break the problem into smaller steps and focus on one at a time.",
              "Listen to calming music.",
              "Ask for help or guidance from a teacher or friend.",
              "Visualize yourself doing well and succeeding.",
              "Do an activity like drawing or playing a game."
            ],
          },
          {
            stepId: 9,
            type: "dropdownScenario",
            question: "You argued with your sibling this morning, and now you're still feeling angry.",
            options: [
              "Take deep breaths and count to ten.",
              "Write down how you feel in a journal.",
              "Take a short walk or move to a quiet space to cool down.",
              "Practice positive self-talk, like 'I can handle this'",
              "Talk to someone you trust.",
              "Break the problem into smaller steps and focus on one at a time.",
              "Listen to calming music.",
              "Ask for help or guidance from a teacher or friend.",
              "Visualize yourself doing well and succeeding.",
              "Do an activity like drawing or playing a game."
            ],
          },
          {
            stepId: 10,
            type: "dropdownScenario",
            question: "You accidentally made a mistake on a school assignment and feel embarrassed.",
            options: [
              "Take deep breaths and count to ten.",
              "Write down how you feel in a journal.",
              "Take a short walk or move to a quiet space to cool down.",
              "Practice positive self-talk, like 'I can handle this'",
              "Talk to someone you trust.",
              "Break the problem into smaller steps and focus on one at a time.",
              "Listen to calming music.",
              "Ask for help or guidance from a teacher or friend.",
              "Visualize yourself doing well and succeeding.",
              "Do an activity like drawing or playing a game."
            ],
          },
          {
            stepId: 11,
            type: "dropdownScenario",
            question: "A teacher called on you to answer a question, but you didn’t know the answer, and now you feel nervous.",
            options: [
              "Take deep breaths and count to ten.",
              "Write down how you feel in a journal.",
              "Take a short walk or move to a quiet space to cool down.",
              "Practice positive self-talk, like 'I can handle this'",
              "Talk to someone you trust.",
              "Break the problem into smaller steps and focus on one at a time.",
              "Listen to calming music.",
              "Ask for help or guidance from a teacher or friend.",
              "Visualize yourself doing well and succeeding.",
              "Do an activity like drawing or playing a game."
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 7,
        type: "video",
        videoSrc: "https://d3sc34m1n26ele.cloudfront.net/resilience_grit_videos/Week+5/Week+5_4.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
    ],
  }
};
